import {getRoles, updateUser} from "API/usersApi";
import LoadingSpinner from "components/Loading/LoadingSpinner";
import {useEffect, useState} from "react";
import {Button, Form, Modal} from "react-bootstrap";
import {toast} from "react-toastify";
import messageFromError from "utils/errorUtils";
import {useTranslation} from "react-i18next";

const ChangeRoleModal = ({show, onHide, onUpdate, user}) => {

    useEffect(() => {
        async function fetchRoles()
        {
          try {
            const response = await getRoles()
            setRoles(response.data)
          }
          catch (error) {
            toast.error(messageFromError(error))
          }
        }
        fetchRoles()
    }, [])

    const [roles, setRoles] = useState([])
    const [selectedRole, setSelectedRole] = useState()
    const [showSpinner, setShowSpinner] = useState(false)

    const {t} = useTranslation()

    useEffect(() => {
      if(user.userRoles.length < 1)
        return;
      
      setSelectedRole(user.userRoles[0].id)
    }, [user])

    async function changeRole()
    {
      try {
        setShowSpinner(true)
        await updateUser(user.id, { roles: [selectedRole] })
        toast.success("Updated")
        onUpdate()
        onHide()
      }
      catch (error) {
        toast.error(messageFromError(error))
      }
      finally {
        setShowSpinner(false)
      }
    }

    return (
      <Modal centered show={show} onHide={() => {!showSpinner && onHide()}}>
            <Modal.Header className='modal-header' closeButton={!showSpinner}>
                <Modal.Title>{t('pages.users.changeRoleDialog.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Select value={selectedRole} onChange={(e) => {setSelectedRole(e.target.value)}}>
                    {roles.map(role => {
                      return (
                        <option key={role.id} value={role.id}>{role.name}</option>
                      )                      
                    })}
                </Form.Select>
            </Modal.Body>
            <Modal.Footer>
                {showSpinner ? <LoadingSpinner variant="success"/> : 
                    <Button variant="success" onClick={changeRole}>{t('global.operations.update')}</Button>
                }
               
            </Modal.Footer>
        </Modal>
    );
};

export default ChangeRoleModal;